export const generateCommonHeader = () => {
  const element = document.createElement('header'),
    h2 = document.createElement('h2');

  element.setAttribute('id', 'header');
  h2.innerText = '$10,000 GIVEAWAY';
  element.append(h2);

  return element;
};

export const generateProgressBar = (count) => {
  const element = document.createElement('div');
  element.setAttribute('id', 'chart');
  element.innerHTML = `<div class="progress-circle" data-count=${count}><div class="progress-number">2 of 4</div></div>`;
  return element;
};
